import ApiService from "@services/api.service";

const Language = {
    list() {
        return ApiService.get("/languages");
    },
    active() {
        return ApiService.get("/languages/active");
    },
    update(id, data) {
        return ApiService.post(`/languages/${id}/update`, data);
    },
    setDefault(id) {
        return ApiService.post(`/languages/${id}/set-default`);
    }
};

export default Language;
